<template>
    <page :title="pageTitle">
        <transition name="page" mode="out-in">
            <form @submit.prevent="passwordChange" v-if="!sent" :key="sent">
                <div class="row">
                    <div class="col-sm-8 offset-sm-2">
                        <div class="form-group" :class="{'has-danger': errors.has('oldpassword')}">
                            <label for="oldpassword">{{ $t('pwd_currentPassword') }}</label>
                            <input v-model="formData.oldpassword"
                                   name="oldpassword"
                                   v-validate="'required|min:3'"
                                   id="oldpassword" type="oldpassword" class="form-control"
                                   :class="{'form-control-danger': errors.has('oldpassword')}">
                            <small class="form-text text-danger" v-if="errors.has('oldpassword')">
                                {{ errors.first('oldpassword') }}
                            </small>
                        </div>
                        <div class="form-group" :class="{'has-danger': errors.has('password')}">
                            <label for="password">{{ $t('pwd_newPassword') }}</label>
                            <input v-model="formData.password"
                                   name="password"
                                   v-validate="'required|min:3|confirmed:confirmpassword'"
                                   id="password" type="password" class="form-control"
                                   :class="{'form-control-danger': errors.has('password')}">
                            <small class="form-text text-danger" v-if="errors.has('password')">
                                {{ errors.first('password') }}
                            </small>
                        </div>
                        <div class="form-group" :class="{'has-danger': errors.has('confirmpassword')}">
                            <label for="password_confirm">{{ $t('pwd_newPasswordConf') }}</label>
                            <input v-model="formData.confirmpassword"
                                   v-validate="'required|min:3'"
                                   ref="confirmpassword"
                                   name="confirmpassword"
                                   id="password_confirm" type="password" class="form-control"
                                   :class="{'form-control-danger': errors.has('confirmpassword')}">
                            <small class="form-text text-danger" v-if="errors.has('confirmpassword')">
                                {{ errors.first('confirmpassword') }}
                            </small>
                        </div>
                        <div class="center">
                            <div class="form-group-btn">
                                <button type="submit" :disabled="errors.any()" class="btn btn-primary pull-right">{{ $t('pwd_changePassword') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row text-center" v-if="sent" :key="sent">
                <div class="col-md-8 offset-md-2">
                    <p>{{ $t('pwd_successChange') }}</p>
                </div>
            </div>
        </transition>
    </page>
</template>

<script>
import Page from './utilities/Page'
import { API } from '../api/axios'
import * as qs from 'qs'
import { mapGetters } from 'vuex'

export default {
  name: 'PasswordChange',
  components: {Page},
  data () {
    return {
      formData: {
        oldpassword: '',
        password: '',
        passwordconfirm: '',
      },
      sent: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'language']),
    pageTitle () {
      return this.sent ? this.$t('pwd_passwordChanged') : this.$t('pwd_changePassword')
    },
  },
  methods: {
    passwordChange () {
      this.$validator.validate().then(result => {
        if (!result) {
          console.log('Invalid!')
        } else {
          let queryString = qs.stringify({...this.formData, email: this.user.email, language: this.language})
          API.post(`/users/changepassword?${queryString}`)
            .then(response => {
              console.log('Password change response', response)
              this.sent = true
            })
            .catch(error => {
              console.error('Password change error', error)
            })
        }
      })
    },
  },
}
</script>

<style scoped>
    .page-enter-active, .page-leave-active {
        transition: opacity .3s;
    }

    .page-enter, .page-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/PasswordChange.vue